// extracted by mini-css-extract-plugin
export default {"DropdownMenuItem":"wellIndexMenu_DropdownMenuItem__48ipm"};